"use strict";

var app = angular.module('rmCampaign');

app.service('itemData', require('./item_data_service.js'));
